import React, { useState, useEffect, Fragment, useCallback } from "react";
import localization from "assets/localization/localization";
import DivLayout from "components/sales/divLayout/divLayout";
import DocumentView from "../../../../../components/sales/downloadDocView/documentView";
import Layout from "../../../../../components/sales/layout/layout";
import { toast } from "react-toastify";
import FormSection from "../../../../../components/sales/formSection/formSection";
import s from "../../../../../components/sales/paymentPortal/addPayment/addPayment.module.css";
import DropDownInput from "../../../../../components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "../../../../../components/sales/Input/constantInput/constantInput";
import { Button } from "react-bootstrap";
import ModalPop from "../../../../../components/sales/modal/modal";

const CaseView = ({
  caseByIdRequest,
  match,
  caseByIdResponse = [],
  caseStatusUpdateRequest,
  caseStatusUpdateResponse = [],
  loanApplicationByIdRequest,
  loanApplicationByIdResponse = [],
  loanAccountRequest,
  loanAccountResponse = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState("");
  const [changeCarLoanStatusModalOpen, setChangeCarLoanStatusModalOpen] =
    useState(false);
  const [statusChangeInput, setStatusChangeInput] = useState({
    status: "",
    remark: "",
    id: "",
  });
  const [roleId, setRoleId] = useState();
  const [userId, setUserId] = useState();
  const [remark, setRemark] = useState();

  console.log(loanAccountResponse);
  useEffect(() => {
    setIsLoading(true);
    (async () => {
      setUserId(JSON.parse(window.localStorage.loginDetails)?.id);
      setRoleId(window.localStorage.getItem("fusion-role"));
      await caseByIdRequest(match?.params?.id);
      await loanApplicationByIdRequest(match?.params?.id);
      await loanAccountRequest(match?.params?.id);
    })();
    setIsLoading(false);
  }, []);

  const submitStatus = async () => {
    statusChangeInput["id"] = match?.params?.id;

    if (!statusChangeInput?.remark && statusChangeInput?.status === 8) {
      toast.error("Remark is required");
      return false;
    } else if (
      !statusChangeInput?.remark &&
      (statusChangeInput?.status === 3 || statusChangeInput?.status === 10)
    ) {
      toast.error("Remark is required");
      return false;
    }
    setChangeCarLoanStatusModalOpen(false);
    setIsLoading(true);
    await caseStatusUpdateRequest(statusChangeInput);
    setIsLoading(false);
  };

  useEffect(() => {
    if (parseInt(caseStatusUpdateResponse?.status) === 200) {
      toast.success(caseStatusUpdateResponse?.message);
      setChangeCarLoanStatusModalOpen(false);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else if (caseStatusUpdateResponse?.status !== 200) {
      toast.error(caseStatusUpdateResponse?.message);
    }
  }, [caseStatusUpdateResponse]);

  const headerBtns = () => {
    return (
      <Fragment>
        {loanApplicationByIdResponse?.data?.status &&
          loanApplicationByIdResponse?.data?.status != "APPROVED" && (
            <Button
              onClick={() => {
                setChangeCarLoanStatusModalOpen(true);
              }}
              className="filter-hamburger btn btn-transparent"
            >
              {"Change Status"}
            </Button>
          )}
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.BacktoList}
      isGoback
      isLoading={isLoading}
      Buttons={
        parseInt(roleId) === 54 ||
        parseInt(roleId) === 41 ||
        parseInt(roleId) === 62
          ? headerBtns
          : ""
      }
    >
      <Fragment>
        {loanApplicationByIdResponse?.data && (
          <>
            {console.log(
              "loanApplicationByIdResponse?.data",
              loanApplicationByIdResponse?.data
            )}
            <div className="panel-card">
              <div className="panel-heading">Case Details</div>
              <div className="panel-body">
                <div className="details-listing">
                  {loanApplicationByIdResponse?.data && (
                    <>
                      <div className="row">
                        <div className="col-6">
                          <DivLayout
                            heading={"Loan Application Id"}
                            data={
                              match?.params?.id
                                ? match?.params?.id
                                : localization.na
                            }
                          />
                        </div>
                        {loanApplicationByIdResponse?.data?.business_name && (
                          <div className="col-6">
                            <DivLayout
                              heading={"Business Name"}
                              data={
                                loanApplicationByIdResponse?.data?.business_name
                                  ? loanApplicationByIdResponse?.data
                                      ?.business_name
                                  : localization.na
                              }
                            />
                          </div>
                        )}

                        <div className="col-6">
                          <DivLayout
                            heading={"Vehicle Type"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_type
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_type
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Entity Type"}
                            data={
                              loanApplicationByIdResponse?.data?.customer_type
                                ? loanApplicationByIdResponse?.data
                                    ?.customer_type
                                : localization.na
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {loanApplicationByIdResponse?.data &&
              loanApplicationByIdResponse?.data?.primary &&
              loanApplicationByIdResponse?.data?.primary &&
              loanApplicationByIdResponse?.data?.primary?.meta_data && (
                <>
                  <div className="panel-card">
                    <div className="panel-heading">Customer Details</div>
                    <div className="panel-body">
                      <div className="details-listing">
                        {loanApplicationByIdResponse &&
                          loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.customer_type &&
                          loanApplicationByIdResponse?.data?.customer_type ==
                            "INDIVIDUAL" && (
                            <>
                              <div className="row">
                                <div className="col-6">
                                  <DivLayout
                                    heading={"Customer First Name"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.first_name
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data?.first_name
                                        : localization.na
                                    }
                                  />
                                </div>
                                <div className="col-6">
                                  <DivLayout
                                    heading={"Customer Last Name"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.last_name
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data?.last_name
                                        : localization.na
                                    }
                                  />
                                </div>
                                <div className="col-6">
                                  <DivLayout
                                    heading={"Customer Mother Name"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.customer_mother_name
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data
                                            ?.customer_mother_name
                                        : localization.na
                                    }
                                  />
                                </div>
                                <div className="col-6">
                                  <DivLayout
                                    heading={"D.O.B."}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.date_of_birth
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data?.date_of_birth
                                        : localization.na
                                    }
                                  />
                                </div>
                                <div className="col-6">
                                  <DivLayout
                                    heading={"Gender"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.gender
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data?.gender
                                        : localization.na
                                    }
                                  />
                                </div>
                                <div className="col-6">
                                  <DivLayout
                                    heading={"Email"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.email
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data?.email
                                        : localization.na
                                    }
                                  />
                                </div>
                                <div className="col-6">
                                  <DivLayout
                                    heading={"Current Address"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.current_address
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data
                                            ?.current_address
                                        : localization.na
                                    }
                                  />
                                </div>
                                <div className="col-6">
                                  <DivLayout
                                    heading={"Permanent Address"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.permanent_address
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data
                                            ?.permanent_address
                                        : localization.na
                                    }
                                  />
                                </div>
                                <div className="col-6">
                                  <DivLayout
                                    heading={"Residence Type"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.residence_type
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data?.residence_type
                                        : localization.na
                                    }
                                  />
                                </div>
                                <div className="col-6">
                                  <DivLayout
                                    heading={"Educational Qualification"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.educational_qualification
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data
                                            ?.educational_qualification
                                        : localization.na
                                    }
                                  />
                                </div>
                              </div>
                            </>
                        )}
                        {loanApplicationByIdResponse &&
                          loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.customer_type &&
                          loanApplicationByIdResponse?.data?.customer_type ==
                            "COMPANY" && (
                            <>
                              <div className="row">
                                <div className="col-6">
                                  <DivLayout
                                    heading={"Company Name"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.company_name
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data?.company_name
                                        : localization.na
                                    }
                                  />
                                </div>
                                <div className="col-6">
                                  <DivLayout
                                    heading={"Company Type"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.company_type
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data?.company_type
                                        : localization.na
                                    }
                                  />
                                </div>
                                <div className="col-6">
                                  <DivLayout
                                    heading={"Co-applicant Relation"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.co_applicant_relation
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data
                                            ?.co_applicant_relation
                                        : localization.na
                                    }
                                  />
                                </div>
                                <div className="col-6">
                                  <DivLayout
                                    heading={"GST Number"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.gst_number
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data?.gst_number
                                        : localization.na
                                    }
                                  />
                                </div>
                                <div className="col-6">
                                  <DivLayout
                                    heading={"Established In"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.established_in
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data?.established_in
                                        : localization.na
                                    }
                                  />
                                </div>
                                <div className="col-6">
                                  <DivLayout
                                    heading={"Email"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.email
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data?.email
                                        : localization.na
                                    }
                                  />
                                </div>
                                <div className="col-6">
                                  <DivLayout
                                    heading={"Address"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.address
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data
                                            ?.address
                                        : localization.na
                                    }
                                  />
                                </div>
                                <div className="col-6">
                                  <DivLayout
                                    heading={"Company Turnover"}
                                    data={
                                      loanApplicationByIdResponse?.data?.primary
                                        ?.meta_data?.company_turnover
                                        ? loanApplicationByIdResponse?.data
                                            ?.primary?.meta_data
                                            ?.company_turnover
                                        : localization.na
                                    }
                                  />
                                </div>
                              </div>
                            </>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            <div className="panel-card">
              <div className="panel-heading">Employee Details</div>
              <div className="panel-body">
                <div className="details-listing">
                  {loanApplicationByIdResponse?.data?.employment_details && (
                    <>
                      <div className="row">
                        <div className="col-6">
                          <DivLayout
                            heading={"Employee Type"}
                            data={
                              loanApplicationByIdResponse?.data
                                ?.employment_details?.employment_type
                                ? loanApplicationByIdResponse?.data
                                    ?.employment_details?.employment_type
                                : localization.na
                            }
                          />
                        </div>

                        <div className="col-6">
                          <DivLayout
                            heading={"Occupation"}
                            data={
                              loanApplicationByIdResponse?.data
                                ?.employment_details?.occupation
                                ? loanApplicationByIdResponse?.data
                                    ?.employment_details?.occupation
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Annual Income"}
                            data={
                              loanApplicationByIdResponse?.data
                                ?.employment_details?.annual_income
                                ? loanApplicationByIdResponse?.data
                                    ?.employment_details?.annual_income
                                : localization.na
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="panel-card">
              <div className="panel-heading">Vehicle Details</div>
              <div className="panel-body">
                <div className="details-listing">
                  {loanApplicationByIdResponse?.data && (
                    <>
                      <div className="row">
                        <div className="col-6">
                          <DivLayout
                            heading={"Vehicle Registration No"}
                            data={
                              loanApplicationByIdResponse?.data
                                ?.vehicle_registration_number
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_registration_number
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Vehicle Brand"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.vehicle_brand
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.vehicle_brand
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Vehicle Model"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.vehicle_model
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.vehicle_model
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Vehicle variant"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.vehicle_variant
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.vehicle_variant
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Year of Manufacturing"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.year_of_manufacturing
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.year_of_manufacturing
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Active Insurance"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.active_insurance
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.active_insurance
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Insurance Validity"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.insurance_validity
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.insurance_validity
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Engine Number"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.engine_number
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.engine_number
                                : localization.na
                            }
                          />
                        </div>

                        <div className="col-6">
                          <DivLayout
                            heading={"Chasis Number"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.chasis_number
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.chasis_number
                                : localization.na
                            }
                          />
                        </div>

                        <div className="col-6">
                          <DivLayout
                            heading={"Ownership Series"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.ownership_series
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.ownership_series
                                : localization.na
                            }
                          />
                        </div>

                        <div className="col-6">
                          <DivLayout
                            heading={"Fuel Type"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.fuel_type
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.fuel_type
                                : localization.na
                            }
                          />
                        </div>

                        <div className="col-6">
                          <DivLayout
                            heading={"Transmission Type"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.transmission_type
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.transmission_type
                                : localization.na
                            }
                          />
                        </div>

                        <div className="col-6">
                          <DivLayout
                            heading={"Current Hypothecation"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.current_hypothecation
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.current_hypothecation
                                : localization.na
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="panel-card">
              <div className="panel-heading">Loan Details</div>
              <div className="panel-body">
                <div className="details-listing">
                  {loanApplicationByIdResponse?.data && (
                    <>
                      <div className="row">
                        <div className="col-6">
                          <DivLayout
                            heading={"Required Loan Amount"}
                            data={
                              loanApplicationByIdResponse?.data
                                ?.loan_required_amount
                                ? loanApplicationByIdResponse?.data
                                    ?.loan_required_amount
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Net Disbursal Amount"}
                            data={
                              loanApplicationByIdResponse?.data
                                .loan_approved_amount
                                ? loanApplicationByIdResponse?.data
                                    ?.loan_approved_amount
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Bank Name"}
                            data={
                              loanApplicationByIdResponse?.data?.bank_name
                                ? loanApplicationByIdResponse?.data?.bank_name
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Loan Tenure"}
                            data={
                              loanApplicationByIdResponse?.data?.loan_tenure
                                ? loanApplicationByIdResponse?.data?.loan_tenure
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Rate Of Interest"}
                            data={
                              loanApplicationByIdResponse?.data
                                ?.rate_of_interest
                                ? loanApplicationByIdResponse?.data
                                    ?.rate_of_interest
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Loan Type"}
                            data={
                              loanApplicationByIdResponse?.data?.loan_type
                                ? loanApplicationByIdResponse?.data?.loan_type
                                : localization.na
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {/* 
            {caseByIdResponse?.data &&
              caseByIdResponse?.data?.meta_data &&
              caseByIdResponse?.data?.meta_data[0] &&
              caseByIdResponse?.data?.meta_data[0]?.company_details && (
                <>
                  <div className="panel-card">
                    <div className="panel-heading">Company Details</div>
                    <div className="panel-body">
                      <div className="details-listing">
                        <div className="row">
                          <div className="col-6">
                            <DivLayout
                              heading={"Company Type"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.company_type
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.company_type
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Co-Application Relation"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.co_application_relation
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.co_application_relation
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Company Pan"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.company_pan
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.company_pan
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Company GST"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.company_gst
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.company_gst
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"ESTD in (Year)"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.estd_year
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.estd_year
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Email"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.email
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.email
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Address"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.address
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.address
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Same for permanent address"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.is_permanent_address
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.is_permanent_address
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Mobile Number"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.phone_no
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.phone_no
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Company Turnover"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.company_turnover
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.company_turnover
                                  : localization.na
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )} */}

            {loanApplicationByIdResponse?.data &&
              loanApplicationByIdResponse?.data?.co_applicant &&
              loanApplicationByIdResponse?.data?.co_applicant?.meta_data && (
                <>
                  <div className="panel-card">
                    <div className="panel-heading">Co-Applicant Details</div>
                    <div className="panel-body">
                      <div className="details-listing">
                        <div className="row">
                          <div className="col-6">
                            <DivLayout
                              heading={"Co-Applicant First Name"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.meta_data?.first_name
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.meta_data?.first_name
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Co-Applicant Last Name"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.meta_data?.last_name
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.meta_data?.last_name
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Role in Company"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.meta_data?.co_applicant_role_in_company
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.meta_data
                                      ?.co_applicant_role_in_company
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Current Address"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.meta_data?.address
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.meta_data?.address
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Mobile Number"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.mobile_number
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.mobile_number
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Email"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.meta_data?.email
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.meta_data?.email
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Date of Birth"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.meta_data?.date_of_birth
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.meta_data?.date_of_birth
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Gender"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.meta_data?.gender
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.meta_data?.gender
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Education Qualification"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.meta_data?.educational_qualification
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.meta_data
                                      ?.educational_qualification
                                  : localization.na
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

            <div className="panel-card">
              <div className="panel-heading">Additional Details</div>
              <div className="panel-body">
                <div className="details-listing">
                  <div className="row">
                    <div className="col-6">
                      <DivLayout
                        heading={"Rc Available"}
                        data={
                          loanApplicationByIdResponse?.data?.is_rc_available
                            ? loanApplicationByIdResponse?.data?.is_rc_available
                            : localization.na
                        }
                      />
                    </div>
                    <div className="col-6">
                      <DivLayout
                        heading={"Rc Transfer By"}
                        data={
                          loanApplicationByIdResponse?.data?.rc_transfer_by
                            ? loanApplicationByIdResponse?.data?.rc_transfer_by
                            : localization.na
                        }
                      />
                    </div>
                    <div className="col-6">
                      <DivLayout
                        heading={"Disbursal Date"}
                        data={
                          loanApplicationByIdResponse?.data?.disbursal_date
                            ? loanApplicationByIdResponse?.data?.disbursal_date
                            : localization.na
                        }
                      />
                    </div>
                    {loanApplicationByIdResponse?.data?.documents?.form_26 && (
                      <div className="col-6">
                        <DocumentView
                          attachment={
                            loanApplicationByIdResponse?.data?.documents
                              ?.form_26
                          }
                          title={"Form 26"}
                        />
                      </div>
                    )}
                    {loanApplicationByIdResponse?.data?.documents
                      ?.bh_approval && (
                      <div className="col-6">
                        <DocumentView
                          attachment={
                            loanApplicationByIdResponse?.data?.documents
                              ?.bh_approval
                          }
                          title={"BH Approval"}
                        />
                      </div>
                    )}
                    {loanApplicationByIdResponse?.data?.documents?.fir && (
                      <div className="col-6">
                        <DocumentView
                          attachment={
                            loanApplicationByIdResponse?.data?.documents?.fir
                          }
                          title={"FIR"}
                        />
                      </div>
                    )}
                    {loanApplicationByIdResponse?.data?.documents
                      ?.undertaking && (
                      <div className="col-6">
                        <DocumentView
                          attachment={
                            loanApplicationByIdResponse?.data?.documents
                              ?.undertaking
                          }
                          title={"Undertaking"}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {loanApplicationByIdResponse?.data &&
              loanApplicationByIdResponse?.data?.documents && (
                <div className="panel-card">
                  <div className="panel-heading">Documents</div>
                  <div className="panel-body">
                    <div className="details-listing">
                      <div className="row">
                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents?.rc && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.rc
                                }
                                title={"RC"}
                              />
                            </div>
                          )}
                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.pan_card && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.pan_card
                                }
                                title={"Pan Card"}
                              />
                            </div>
                          )}
                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.aadhar_card && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.aadhar_card
                                }
                                title={"Adhaar Card"}
                              />
                            </div>
                          )}
                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.rent_agreement && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.rent_agreement
                                }
                                title={"Rent Agreement"}
                              />
                            </div>
                          )}

                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.business_proof && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.business_proof
                                }
                                title={"Business proof (GST/MSME)"}
                              />
                            </div>
                          )}

                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.electricity_bill && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.electricity_bill
                                }
                                title={"Electricity Bill"}
                              />
                            </div>
                          )}

                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.salary_slip && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.salary_slip
                                }
                                title={`Salary Slip`}
                              />
                            </div>
                          )}

                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.bank_statement && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.bank_statement
                                }
                                title={"Bank Statement"}
                              />
                            </div>
                          )}

                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.insurance_certificate && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.insurance_certificate
                                }
                                title={"Insurance Certificate"}
                              />
                            </div>
                          )}

                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.addition_documents && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.addition_documents
                                }
                                title={"Addition Doc"}
                              />
                            </div>
                          )}
                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.disbursal_memo && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.disbursal_memo
                                }
                                title={"Disbursal Memo"}
                              />
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </>
        )}
        <ModalPop
          title={"Change Status"}
          show={changeCarLoanStatusModalOpen}
          handleModalHide={() => {
            setChangeCarLoanStatusModalOpen(false);
          }}
        >
          <Fragment>
            <FormSection>
              <div className={s.root}>
                <div className={s.root}>
                  <div>
                    <div className="col-sm-12 col-ms-12 ">
                      {parseInt(roleId) === 54 &&
                        (loanApplicationByIdResponse?.data?.status ==
                          "LOGGED_IN" ||
                          loanApplicationByIdResponse?.data?.status ==
                            "APPROVED" ||
                          loanApplicationByIdResponse?.data?.status ==
                            "REQUEST_FOR_CASE_APPROVAL") && (
                          <DropDownInput
                            label={"Status"}
                            data={[
                              { id: 2, name: "Approve" },
                              { id: 3, name: "Reject" },
                              { id: 10, name: "Cancelled" },
                              { id: 8, name: "Back to Modification" },
                            ]}
                            value={""}
                            isStarRequired={true}
                            getIdValue={(val) => {
                              setStatusChangeInput({
                                ...statusChangeInput,
                                status: val.id,
                              });
                            }}
                            required={true}
                          />
                        )}

                      {parseInt(roleId) === 54 &&
                        (loanApplicationByIdResponse?.data?.status ==
                          "REJECTED" ||
                          loanApplicationByIdResponse?.data?.status ==
                            "CANCELLED") && (
                          <DropDownInput
                            label={"Status"}
                            data={[{ id: 9, name: "Logged In" }]}
                            value={""}
                            isStarRequired={true}
                            getIdValue={(val) => {
                              setStatusChangeInput({
                                ...statusChangeInput,
                                status: val.id,
                              });
                            }}
                            required={true}
                          />
                        )}

                      {(parseInt(roleId) === 41 || parseInt(roleId) === 62) &&
                        loanApplicationByIdResponse?.data?.status ==
                          "LOGGED_IN" && (
                          <DropDownInput
                            label={"Status"}
                            data={[
                              { id: 11, name: "Approval Request" },
                              { id: 10, name: "Cancelled" },
                              { id: 1, name: "Reject" },
                            ]}
                            value={""}
                            isStarRequired={true}
                            getIdValue={(val) => {
                              setStatusChangeInput({
                                ...statusChangeInput,
                                status: val.id,
                              });
                            }}
                            required={true}
                          />
                        )}
                    </div>

                    <div className="col-sm-12 col-ms-12 ">
                      <ConstantInput
                        label={localization.remark}
                        type="text"
                        value={""}
                        required={true}
                        className="my-custom-datepicker-component "
                        handleChange={(val) =>
                          setStatusChangeInput({
                            ...statusChangeInput,
                            remark: val,
                          })
                        }
                      />
                    </div>

                    <br />
                    <Button
                      className="btn btn-success"
                      onClick={() => submitStatus()}
                    >
                      {"Final Submit"}
                    </Button>
                  </div>
                </div>
              </div>
            </FormSection>
          </Fragment>
        </ModalPop>
      </Fragment>
    </Layout>
  );
};

export default CaseView;
